import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import { ddStyles } from "../../utils/CommonStyles.js";
import PartnerDelegateReadOnlyRow from "../../components/PartnerDelegateReadOnlyRow";
import PartnerDelegateTableRow from "../../components/PartnerDelegateTableRow";
import PartnerDelegateNoOpRow from "../../components/PartnerDelegateNoOpRow";
import ListDelegateAppSurveys from "./ListDelegateAppSurveys";
import ListDelegateLocations from "./ListDelegateLocations";
import ListDelegateProducts from "./ListDelegateProducts";


function ListPartnerDelegates() {
	const navigate = useNavigate();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);

	const [errorValue, setErrorValue] = useState("");
	const [delegates, setDelegates] = useState([]);
	const [otherDelegates, setOtherDelegates] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [supplierOptions, setSupplierOptions] = useState([]);
	const [supplierCompanyId, setSupplierCompanyId] = useState(0);
	const [supplierLoaded, setSupplierLoaded] = useState(false);
	const [supplierSelected, setSupplierSelected] = useState({ name: "supplierId", label: "", value: '0-0' });
	const [buyers, setBuyers] = useState([]);
	const [buyerOptions, setBuyerOptions] = useState([]);
	const [buyerLoaded, setBuyerLoaded] = useState(false);
	const [buyerSelected, setBuyerSelected] = useState({ name: "buyerId", label: "", value: 0 });
	const [buyerCompanyId, setBuyerCompanyId] = useState(0);
	const [secondarySuppliers, setSecondarySuppliers] = useState([]);
	const [count, setCount] = useState(0);
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);
	const [isLoading, setIsLoading] = useState(false);
	const [level, setLevel] = useState(1);
	const [levelSelected, setLevelSelected] = useState({ name: "level", label: t("page.level") + " 1", value: 1 });
	const [levelOptions, setLevelOptions] = useState([]);
	const [levelLoaded, setLevelLoaded] = useState(false);
	const [parentSuppliers, setParentSuppliers] = useState([]);
	const [location, setLocation] = useState(false);
	const [appSurvey, setAppSurvey] = useState(false);
	const [product, setProduct] = useState(false);
	const [selectedDelegate, setSelectedDelegate] = useState({});

	const initialValues = {
		delegateKey: 0,
		partnershipKey: 0,
		partnerKey: 0,
		companyKey: 0,
		statusCode: 1,
		level: 1,
		parentDelegateKey: 0,
		parentSupplierKey: 0,
		startDate: "",
		endDate: "",
	};

	const [editFormData, setEditFormData] = useState(initialValues);

	useEffect(() => {
		fetchBuyers();
		setLevelValues();
	}, []);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	function fetchBuyers() {
		setErrorValue("");
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("FetchBuyers", "/Service/CompanyService/FetchBuyers", requestOptions, fetchBuyersSuccess, fetchBuyersFail);
		} catch (error) {
			throw new Error(error.message);
		}
	}

	function fetchBuyersFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.buyerListNotRetrieved"));
	}
	function fetchBuyersSuccess(responseData) {
		let fetchBuyersResponse;
		if (responseData) {
			fetchBuyersResponse = responseData.fetchBuyersResponse;
			if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "0") {
				setBuyerValues(fetchBuyersResponse.companies);
				setBuyers(fetchBuyersResponse.companies);
			} else if (fetchBuyersResponse && fetchBuyersResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchBuyersResponse) {
				setErrorValue(t("error.error") + " " + fetchBuyersResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}
	function setSupplierValues(companyObj) {
		let companyValue = {};
		let companyOptionList = [];
		companyOptionList.push({ label: "", value: '0-0' });
		if (companyObj && companyObj.length > 0) {
			companyObj.map((company, index) => {
				companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
				companyValue.value = company.companyId + '-' + company.partnershipKey;
				companyOptionList.push(companyValue);
				companyValue = {};
			});
		}
		setSupplierOptions(companyOptionList);
		setSupplierLoaded(true);
	}
	const supplierHandler = (selectedOption, action) => {
		let supplierIdValue = selectedOption ? selectedOption.value : '0-0';
		let companyName = selectedOption ? selectedOption.label : "";
		let supplierArr = supplierIdValue.split('-');
		let companyId = supplierArr[0];
		let partnershipId = supplierArr[1];
		if (companyId === supplierCompanyId) {
			return;
		}
		setParentSuppliers([]);
		setDelegates([]);
		setOtherDelegates([]);
		setSecondarySuppliers([]);
		setLevelSelected({ ...levelSelected, label: t("page.level") + " 1", value: 1 });
		setLevel(1);
		removeRowTable();
		setSupplierCompanyId(companyId);
		setSupplierSelected({ ...supplierSelected, label: companyName, value: supplierIdValue });
		setEditFormData({ ...editFormData, level: 1, partnershipKey: partnershipId });
		if (companyId && companyId > 0) {
			fetchSecondarySuppliers(companyId);// fetch all suppliers
		}
	}

	function setLevelValues() {
		let levelOptionList = [];
		levelOptionList.push({ label: t("page.level") + " 1", value: 1 });
		for (let i = 2; i < 11; i++) {
			levelOptionList.push({ label: t("page.level") + " " + i, value: i });
		}
		setLevelOptions(levelOptionList);
		setLevelLoaded(true);
	}

	const levelHandler = (selectedOption, action) => {
		let levelNum = selectedOption ? selectedOption.value : 0;
		setLevelSelected({ ...levelSelected, label: t("page.level") + " " + levelNum, value: levelNum });
		removeRowTable();
		setLevel(levelNum);
		setDelegates([]);
		setOtherDelegates([]);
		setParentSuppliers([]);
		setEditFormData({ ...editFormData, level: levelNum });

	}
	function fetchSecondarySuppliers(clientId){
		setErrorValue("");
		if ((!clientId || clientId === 0)) {
			return;
		}

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				clientCompanyId: clientId,
				includeInactivePartner: true
			}),
		};
		try {
			if (clientId > 0) {
				FetchUtil.fetchAPI("GetPartners", "/Service/CompanyService/GetPartners", requestOptions, fetchSecondarySupplierSuccess, fetchPartnerFail);
			}

		} catch (error) {
			throw new Error(error.message);
		}
	}
	function fetchPartners(clientId) {
		setErrorValue("");
		if ((!clientId || clientId === 0)) {
			return;
		}

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				clientCompanyId: clientId,
				includeInactivePartner: true
			}),
		};
		try {
			if (clientId > 0) {
				FetchUtil.fetchAPI("GetPartners", "/Service/CompanyService/GetPartners", requestOptions, fetchSupplierSuccess, fetchPartnerFail);
			}

		} catch (error) {
			throw new Error(error.message);
		}
	}
	function fetchSupplierSuccess(responseData) {
		let getPartnersResponse;
		if (responseData) {
			getPartnersResponse = responseData.getPartnersResponse;
			if (getPartnersResponse && getPartnersResponse.errorCode === "0") {
				setSupplierValues(getPartnersResponse.partnerList.slice());
				if (getPartnersResponse.partnerList) {
					setSuppliers(getPartnersResponse.partnerList.slice());
				}
			} else if (getPartnersResponse && getPartnersResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnersResponse) {
				setErrorValue(t("error.error") + " " + getPartnersResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}

	function fetchSecondarySupplierSuccess(responseData) {
		let getPartnersResponse;
		if (responseData) {
			getPartnersResponse = responseData.getPartnersResponse;
			if (getPartnersResponse && getPartnersResponse.errorCode === "0") {
				if (getPartnersResponse.partnerList) {
					setSecondarySuppliers(getPartnersResponse.partnerList.slice());
				}
			} else if (getPartnersResponse && getPartnersResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnersResponse) {
				setErrorValue(t("error.error") + " " + getPartnersResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}

	function fetchPartnerFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.partnerNotRetrieved"));
	}

	function setBuyerValues(buyers) {
		let buyerValue = {};
		let buyerOptionList = [];
		buyerOptionList.push({ label: "", value: 0 });
		if (buyers && buyers.length > 0) {
			buyers.map((buyer, index) => {
				buyerValue.label = buyer.companyName + ', ' + (buyer.city ? buyer.city + ', ' : '') + buyer.stateCode + ', ' + buyer.countryCode;
				buyerValue.value = buyer.companyId;
				buyerOptionList.push(buyerValue);
				buyerValue = {};
			});
		}
		setBuyerOptions(buyerOptionList);
		setBuyerLoaded(true);
	}
	const buyerHandler = (selectedOption, action) => {
		let companyId = selectedOption ? selectedOption.value : 0;
		let companyName = selectedOption ? selectedOption.label : "";
		if (companyId === buyerCompanyId) {
			return;
		}
		removeRowTable();
		setParentSuppliers([]);
		setDelegates([]);
		setOtherDelegates([]);
		setLevelSelected({ ...levelSelected, label: t("page.level") + " 1", value: 1 });
		setLevel(1);
		setSupplierCompanyId(0);
		setSupplierSelected({ ...supplierSelected, label: "", value: '0-0' });
		setSuppliers([]);
		setSupplierOptions([]);
		setBuyerCompanyId(companyId);
		setBuyerSelected({ ...buyerSelected, label: companyName, value: companyId });
		setEditFormData({ ...editFormData, companyKey: companyId, level: 1 });
		if (companyId && companyId > 0) {
			fetchPartners(companyId);// fetch all suppliers
		}
	}
	function fetchPartnerDelegate() {
		setErrorValue("");
		let companyId = editFormData.companyKey;
		let partnershipId = editFormData.partnershipKey;
		let levelNum = editFormData.level;
		if ((!partnershipId || partnershipId == 0)) {
			setErrorValue(t("error.supplier.Reqd"));
			return;
		}
		if ((!companyId || companyId == 0)) {
			setErrorValue(t("error.buyer.Reqd"));
			return;
		}
		setIsLoading(true);
		resetCounter();
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true,
				partnershipKey: partnershipId,
				buyerCompanyId: companyId,
				level: levelNum,
				allHeirarchies : true,
			}),
		};
		try {
			FetchUtil.fetchAPI("GetPartnerDelegate", "/Service/CompanyService/GetPartnerDelegate", requestOptions, fetchPartnerDelegateSuccess, fetchPartnerDelegateFail);
		} catch (error) {
			setIsLoading(false);
			throw new Error(error.message);
		}
	}

	function fetchPartnerDelegateFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.partnerDelegateNotRetrieved"));
	}

	function fetchPartnerDelegateSuccess(responseData) {
		let getPartnerDelegateResponse;
		if (responseData) {
			getPartnerDelegateResponse = responseData.getPartnerDelegateResponse;
			if (getPartnerDelegateResponse && getPartnerDelegateResponse.errorCode === "0") {
				if (getPartnerDelegateResponse.companies) {
					setDelegates([...getPartnerDelegateResponse.companies]);
					setOtherDelegates([...getPartnerDelegateResponse.delegates]);
				} else {
					setDelegates([]);
					setOtherDelegates([]);
				}
			} else if (getPartnerDelegateResponse && getPartnerDelegateResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getPartnerDelegateResponse) {
				setErrorValue(t("error.error") + " " + getPartnerDelegateResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
		setIsLoading(false);
	}
	const searchRecords = () => {
		reloadSupplierData();
	}

	function reloadSupplierData() {
		setParentSuppliers([]);
		setDelegates([]);
		setOtherDelegates([]);
		removeRowTable();
		if (editFormData.level > 1) {
			fetchParentSuppliers();
		}
		fetchPartnerDelegate();

	}
	function fetchParentSuppliers() {
		setErrorValue("");
		let companyId = editFormData.companyKey;
		let partnershipId = editFormData.partnershipKey;
		let levelNum = editFormData.level;
		if ((!partnershipId || partnershipId == 0)) {
			setErrorValue(t("error.supplier.Reqd"));
			return;
		}
		if ((!companyId || companyId == 0)) {
			setErrorValue(t("error.buyer.Reqd"));
			return;
		}
		setIsLoading(true);
		resetCounter();
		let serverParams = {
			source: "web", getAll: false,
			partnershipKey: partnershipId,
			buyerCompanyId: companyId,
			level: levelNum,
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("GetParentSupplier", "/Service/CompanyService/GetParentSupplier", requestOptions, fetchParentSupplierSuccess, fetchParentSupplierFail);
		} catch (error) {
			setIsLoading(false);
			throw new Error(error.message);
		}
	}

	function fetchParentSupplierFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.parentSupplierNotRetrieved"));
	}

	function fetchParentSupplierSuccess(responseData) {
		let getParentSupplierResponse;
		if (responseData) {
			getParentSupplierResponse = responseData.getParentSupplierResponse;
			if (getParentSupplierResponse && getParentSupplierResponse.errorCode === "0") {
				if (getParentSupplierResponse.companies) {
					setParentSuppliers([...getParentSupplierResponse.companies]);
				} else {
					setParentSuppliers([]);
				}
			} else if (getParentSupplierResponse && getParentSupplierResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getParentSupplierResponse) {
				setErrorValue(t("error.error") + " " + getParentSupplierResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
		setIsLoading(false);
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setErrorValue("");
		if (!add) {
			setAdd(true);
		} else {
			setErrorValue(t("error.only1RowAllowed"));
		}
	};
	const removeRowTable = () => {
		setErrorValue("");
		resetRowTable();
		setIsLoading(false);
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleDeleteClick = (event, partnerDelegateItem, completeCallback) => {
		event.preventDefault();
		setErrorValue("");
		deletePartnerDelegate(partnerDelegateItem, completeCallback);
	};
	const handleLocation = (event, delegateItem) => {
		event.preventDefault();
		setErrorValue("");
		setLocation(!location);
		setSelectedDelegate(delegateItem);
	};
	const handleAppSurvey = (event, delegateItem) => {
		event.preventDefault();
		setErrorValue("");
		setAppSurvey(!appSurvey);
		setSelectedDelegate(delegateItem);
	};
	const handleProduct = (event, delegateItem) => {
		event.preventDefault();
		setErrorValue("");
		setProduct(!product)
		setSelectedDelegate(delegateItem);
	};
	const deletePartnerDelegate = (partnerDelegateItem, completeCallback) => {
		let action = 3;
		if (partnerDelegateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			delegateKey: partnerDelegateItem.delegateKey,
			statusCode: partnerDelegateItem.statusCode,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("DeletePartnerDelegate", "/Service/CompanyService/DeletePartnerDelegate", requestOptions, deletePartnerDelegateSuccess, deletePartnerDelegateFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	}

	function deletePartnerDelegateFail(redirect, completeCallback) {
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.partnerDelegateDeleteFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deletePartnerDelegateSuccess(responseData, completeCallback) {
		let deletePartnerDelegateResponse;
		if (responseData) {
			deletePartnerDelegateResponse = responseData.deletePartnerDelegateResponse;
			if (deletePartnerDelegateResponse && deletePartnerDelegateResponse.errorCode === "0") {
				resetRowTable();
				fetchPartnerDelegate();
			} else if (deletePartnerDelegateResponse && deletePartnerDelegateResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else {
				setErrorValue(t("error.error") + " " +
					deletePartnerDelegateResponse.errorMessage
				);
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const handleSubmit = (action, setValues, completeCallback) => {
		setErrorValue("");
		let found = false;
		if (action == 1) {
			editFormData.partnerKey = setValues.partnerKey;
			editFormData.parentDelegateKey = setValues.parentDelegateKey;
			editFormData.parentSupplierKey = setValues.parentSupplierKey;
		} else {
			editFormData.delegateKey = setValues.delegateKey;
			editFormData.partnerKey = setValues.partnerKey;
			editFormData.parentDelegateKey = setValues.parentDelegateKey;
		}

		editFormData.startDate = setValues.startDate;
		editFormData.endDate = setValues.endDate;
		if (action == 1) {
			if (editFormData.partnerKey == editFormData.companyKey) {
				setErrorValue(t("error.invalid.delegate.relation"));
				if (completeCallback) {
					completeCallback();
				}
				return false;
			}
			if (editFormData.partnerKey == editFormData.parentSupplierKey) {
				setErrorValue(t("error.invalid.parent.child.relation"));
				if (completeCallback) {
					completeCallback();
				}
				return false;
			}
			if (!editFormData.partnerKey) {
				setErrorValue(t("error.suplrReqd"));
				if (completeCallback) {
					completeCallback();
				}
				return false;
			}
			if (!editFormData.companyKey) {
				setErrorValue(t("error.buyer.Reqd"));
				if (completeCallback) {
					completeCallback();
				}
				return false;
			}
			if (delegates.length > 0) {
				delegates.map((dataItem, index) => {
					if (dataItem.companyKey == editFormData.companyKey
						&& dataItem.partnerKey == editFormData.partnerKey
						&& dataItem.partnershipKey == editFormData.partnershipKey) {
						setErrorValue(t("error.partnerDelegateDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				savePartnerDelegate(action, completeCallback);
			}
		} else {
			savePartnerDelegate(action, completeCallback);
		}
	};
	const savePartnerDelegate = (action, completeCallback) => {
		let serverParams = {};
		if (action == 1) {
			serverParams = {
				companyId: editFormData.companyKey,
				partnerKey: editFormData.partnerKey,
				partnershipKey: editFormData.partnershipKey,
				parentDelegateKey: editFormData.parentDelegateKey,
				parentSupplierKey: editFormData.parentSupplierKey,
				level: editFormData.level,
				startDate: editFormData.startDate,
				endDate: editFormData.endDate,
				source: "web",
				action: action
			};
		} else {
			serverParams = {
				delegateKey: editFormData.delegateKey,
				startDate: editFormData.startDate,
				endDate: editFormData.endDate,
				partnerKey: editFormData.partnerKey,
				partnershipKey: editFormData.partnershipKey,
				parentDelegateKey: editFormData.parentDelegateKey,
				companyId: editFormData.companyKey,
				level: editFormData.level,
				source: "web",
				action: action
			};
		}

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdatePartnerDelegate", "/Service/CompanyService/AddUpdatePartnerDelegate", requestOptions, savePartnerDelegateSuccess, savePartnerDelegateFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function savePartnerDelegateFail(redirect, completeCallback) {
		setErrorValue(t("error.partnerDelegateSaveFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function savePartnerDelegateSuccess(responseData, completeCallback) {
		let addUpdatePartnerDelegateResponse;
		if (responseData) {
			addUpdatePartnerDelegateResponse = responseData.addUpdatePartnerDelegateResponse;
			if (addUpdatePartnerDelegateResponse) {
				if (addUpdatePartnerDelegateResponse.errorCode === "0") {
					resetRowTable();
					fetchPartnerDelegate();
				} else if (addUpdatePartnerDelegateResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						addUpdatePartnerDelegateResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	return (
		<div className="container-fluid">
			<Header />
			<div className={"container-fluid container_list viewh-85"}>
				{(userCtx.role === "SiteAdmin") ?
					<>
						<div className="row">
							<div className="col">
								<div
									id="inerrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg"></div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.buyer")}
									</label>
									<Select
										name="buyerId"
										options={buyerOptions}
										onChange={buyerHandler}
										placeholder={""}
										value={buyerSelected}
										isSearchable={buyerLoaded}
										isClearable={buyerLoaded}
										className="myselect"
										inputId="buyerId-input"
										styles={ddStyles}
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.supplier")}
									</label>
									<Select
										name="supplierId"
										options={supplierOptions}
										onChange={supplierHandler}
										placeholder={""}
										value={supplierSelected}
										isSearchable={supplierLoaded}
										isClearable={supplierLoaded}
										className="myselect"
										inputId="supplierId-input"
										styles={ddStyles}
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.level")}
									</label>
									<Select
										name="level"
										options={levelOptions}
										onChange={levelHandler}
										placeholder={""}
										value={levelSelected}
										isSearchable={levelLoaded}
										isClearable={levelLoaded}
										className="myselect"
										inputId="levelId-input"
										styles={ddStyles}
									/>
								</div>
							</div>
							<div className="col-md-12 text-center">
								<button type="submit"
									className="btn btn-primary btn-block search-button"
									onClick={searchRecords}>
									<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
								</button>
							</div>
							{(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.parentSupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.secondarySupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.startDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.endDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.action")}</th>
											<th className="list-th" style={{ maxWidth: "15vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<PartnerDelegateTableRow
												index={count}
												level={level}
												parentSuppliers={parentSuppliers}
												secondarySuppliers={secondarySuppliers}
												buyerCompanyId={buyerCompanyId}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												setErrorValue={setErrorValue}
												oddIdx={((delegates.length % 2) > 0) ? true : false} />
										}
										{delegates.length > 0 && (
											delegates.map((delegateItem, index) => (
												<PartnerDelegateReadOnlyRow
													index={count}
													t={t}
													delegateItem={delegateItem}
													handleDeleteClick={handleDeleteClick}
													handleSubmit={handleSubmit}
													handleAppSurvey={handleAppSurvey}
													handleLocation={handleLocation}
													handleProduct={handleProduct}
													oddIdx={((index % 2) > 0) ? true : false}
													setError={setErrorValue}
												/>
											))
										)}
										{add && addRowBottom &&
											<PartnerDelegateTableRow
												index={count}
												level={level}
												parentSuppliers={parentSuppliers}
												secondarySuppliers={secondarySuppliers}
												buyerCompanyId={buyerCompanyId}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												oddIdx={((delegates.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(delegates.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.parentSupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.secondarySupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.startDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.endDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.action")}</th>
											<th className="list-th" style={{ maxWidth: "15vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
							</div>
						</div>
						
						{(otherDelegates && otherDelegates.length > 0) ? 
							otherDelegates.map((otherDelegateItem) => (
						<>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>
						
						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr>
											<th className="my-custom-row" colSpan={5}>{t("page.level") + " - " + otherDelegateItem.level}</th>
										</tr>
										<tr role="row">
											<th className="list-th" style={{ maxWidth: "35vw" }}>{t("page.parentSupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "35vw" }}>{t("page.secondarySupplierName")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.startDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.endDate")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{otherDelegateItem.companies.length > 0 && (
											otherDelegateItem.companies.map((companyObj, innerIndx) => (
												<PartnerDelegateNoOpRow
													index={count}
													delegateItem={companyObj}
													oddIdx={((innerIndx % 2) > 0) ? true : false}
												/>
											))
										)}
										
									</tbody>
								</table>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>
						</>
					))
 					: (<></>)}
						<div className="row">
							<div className="col">
								<div
									id="berrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>
					</>
					: null}
					{appSurvey && <ListDelegateAppSurveys 
										indirectBuyerKey={editFormData.companyKey} 
										buyerKey={supplierCompanyId} 
										partnershipKey={editFormData.partnershipKey}
										selectedDelegate = {selectedDelegate}
										level={level} 
										setAppSurvey={setAppSurvey}
									/>}
					{location && <ListDelegateLocations 
										indirectBuyerKey={buyerCompanyId} 
										buyerKey={supplierCompanyId} 
										partnershipKey={editFormData.partnershipKey} 
										selectedDelegate = {selectedDelegate}
										level={level} 
										setLocation={setLocation}
									/>}
					{product && <ListDelegateProducts 
										indirectBuyerKey={buyerCompanyId} 
										buyerKey={supplierCompanyId} 
										partnershipKey={editFormData.partnershipKey} 
										selectedDelegate = {selectedDelegate}
										level={level} 
										setProduct={setProduct}
									/>}
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default ListPartnerDelegates;